import React, { Fragment } from 'react';
import { Intro, Accordion, Button, Scoreboard, ReviewSheet } from 'dea-core';
// import certFile from '%PUBLIC_URL%/pdfs/Operation_Prevention_Workplace_Certificate_Module_1.pdf';
import introImg from '../../assets/images/U1-T1-14A.svg';

// We do use noopener in the link below, but jsx-no-target-blank also demands noreferrer for older browsers which we haven't set
/* eslint-disable react/jsx-no-target-blank */
const data = {
  title: 'Review Answer Sheet',
  content: <ReviewSheet />
};
// {
//   title: 'Explore Additional Modules',
//   content: (
//     <Fragment>
//       <p>
//         <strong>Pathway to Financial Success</strong>
//         <br />
//         Empower high school students to take control of their financial futures.
//         Educators can help students and their families explore comprehensive
//         financial literacy resources to gain the tools and skills they need to
//         make sound financial decisions and achieve their personal goals.
//         <br />
//         <a
//           href="https://www.pathwayinschools.com/"
//           rel="noopener"
//           target="_blank"
//         >
//           www.pathwayinschools.com
//         </a>
//       </p>
//     </Fragment>
//   )
// }

/* eslint-enable react/jsx-no-target-blank */

export default {
  title: 'Results',
  path: '/evaluate/results',
  content: (
    <Fragment>
      <Intro
        title="Results"
        lead="Thank you for taking the time to learn about the opioid epidemic. Here’s just a small snapshot of what you’ve learned. See you in the next module: The Science of Opioids."
        img={introImg}
      />

      <div className="base-completion">

      <iframe
          title='Certificate Module 1'
          src="https://surveys.discoveryeducation.com/s3/DEA-Module-1-Post"
          frameborder="0"
          width="700"
          height="550"
          style={{
            overflow: 'hidden'
          }}
        />

        <Scoreboard />

        {/* <Button
          classes={{ 'cert-download': true }}
          children="Download Certificate"
          file={`${
            process.env.PUBLIC_URL
          }/Operation_Prevention_Workplace_Certificate_Module_1.pdf`}
        /> */}
      </div>

      <Accordion data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/evaluate/Results.js